<template>
<div>
	<div>
		<div class="col-lg-12">
			<h2 class="page-header">
				<span id="page-header">{{ pageheader }}</span>
				<a href="/users/" class="hidden-md hidden-lg"><button class="btn btn-success">Zur Liste</button></a>
			</h2>

			<div class="row">
				<h3 class="col-lg-12">Allgemeine Informationen  <router-link class="btn btn-primary create-new pull-right" to="/users/new"><i class="fa fa-plus"></i></router-link></h3>
				<div class="form-horizontal" id="customer-information">

					<div class="row">
						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="firstname">Vorname</label>
								<div class="col-sm-12">
									<input id="firstname" name="firstname" class="form-control" v-model="model.model.firstname" required>
								</div>
							</custom-input>
						</div>

						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="lastname">Nachname</label>
								<div class="col-sm-12">
									<input id="lastname" name="lastname" class="form-control" v-model="model.model.lastname" required>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="col-lg-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="username">Loginname</label>
								<div class="col-sm-12">
									<input id="username" name="username" class="form-control" v-model="model.model.username":readonly="model.model.id === 0 ? null : 'readonly'" required>
								</div>
							</custom-input>
						</div>

						<div class="col-lg-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="password">Passwort</label>
								<div class="col-sm-12">
									<input id="password" name="password" class="form-control" v-model="model.model.password" type="password" :placeholder="model.model.id === 0 ? 'Passwort eingeben' : '[Nicht ändern]'" required>
								</div>
							</custom-input>
						</div>

						<div class="col-lg-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="repassword">Passwort wiederholen</label>
								<div class="col-sm-12">
									<input id="repassword" name="password" class="form-control" v-model="model.model.repassword" type="password" :placeholder="model.model.password === '' ? '[Nicht ändern]' : 'Passwort wiederholen'" required>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="superior">Vorgesetzter</label>
								<div class="col-sm-12">
									<div class="input-group" v-if="isSuperadmin()">
										<input id="superior" name="superior" class="form-control" required="required" v-model="model.model.superior_name" readonly="readonly">
										<span class="input-group-addon addon-primary" @click="selectSuperior()"><i class="fa fa-pencil"></i></span>
									</div>
									<input v-if="!isSuperadmin()" class="form-control" v-model="model.model.superior_name" readonly="readonly">
								</div>
							</custom-input>
						</div>

						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="role">Rolle</label>
								<div class="col-sm-12">
									<div class="input-group">
										<input id="role" name="role" class="form-control" required="required" v-model="model.model.role_name" readonly="readonly">
										<span class="input-group-addon addon-primary" @click="selectRole()"><i class="fa fa-pencil"></i></span>
									</div>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="form-group">
							<div class="col-lg-12 text-center">
								<a href="/users/" class="hidden-sm hidden-xs"><button class="btn btn-success">Zur Liste</button></a>
								<button class="btn btn-primary" @click="saveUser()">Speichern</button>
							</div>
						</div>
					</div>


					<div class="row">
						<div class="col-lg-12">
							<div class="col-lg-12">
								<ul class="nav nav-tabs responsive-tabs">
									<li class="active"><a href="#permissions">Zugriffsstufen</a></li>
									<li><a href="#addresses">Adressen</a></li>
									<li><a href="#contacts">Kontakte</a></li>
								</ul>

								<div class="tab-content col-lg-12">
									<div class="tab-pane" id="addresses">
										<custom-table :cols="addresses.cols" :src-model="model.addresses" add delete edit nosort @add="addAddress" @edit="editAddress" @delete="deleteAddress"></custom-table>
									</div>

									<div class="tab-pane" id="contacts">
										<custom-table :cols="contacts.cols" :src-model="model.contacts" add delete edit nosort @add="addContact" @edit="editContact" @delete="deleteContact"></custom-table>
									</div>

									<div class="tab-pane active" id="permissions">
										<table class="table table-striped table-hover">
											<thead>
												<tr>
													<th style="width: 200px">Bereich</th>
													<th>Berechtigungsstufe</th>
													<th style="width: 200px">Rolle</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>Dashboard</td>
													<td>
														<vue-slider ref="dashboard" @callback="changeIndex('dashboard')" v-bind="sliderTemplate" v-model="model.model.rightValues.dashboard"></vue-slider>
													</td>
													<td>{{ model.model.role.dashboard }}</td>
												</tr>
												<tr>
													<td>Verstorbene</td>
													<td>
														<vue-slider ref="deceaseds" @callback="changeIndex('deceaseds')" v-bind="sliderTemplate" v-model="model.model.rightValues.deceaseds"></vue-slider>
													</td>
													<td>{{ model.model.role.deceaseds }}</td>
												</tr>
												<tr>
													<td>Kunden</td>
													<td>
														<vue-slider ref="customers" @callback="changeIndex('customers')" v-bind="sliderTemplate" v-model="model.model.rightValues.customers"></vue-slider>
													</td>
													<td>{{ model.model.role.customers }}</td>
												</tr>
												<tr>
													<td>Gräber</td>
													<td>
														<vue-slider ref="graves" @callback="changeIndex('graves')" v-bind="sliderTemplate" v-model="model.model.rightValues.graves"></vue-slider>
													</td>
													<td>{{ model.model.role.graves }}</td>
												</tr>
												<tr>
													<td>Flächen</td>
													<td>
														<vue-slider ref="areas" @callback="changeIndex('areas')" v-bind="sliderTemplate" v-model="model.model.rightValues.areas"></vue-slider>
													</td>
													<td>{{ model.model.role.areas }}</td>
												</tr>
												<tr>
													<td>Krematorien</td>
													<td>
														<vue-slider ref="crematories" @callback="changeIndex('crematories')" v-bind="sliderTemplate" v-model="model.model.rightValues.crematories"></vue-slider>
													</td>
													<td>{{ model.model.role.crematories }}</td>
												</tr>
												<tr>
													<td>Bestatter</td>
													<td>
														<vue-slider ref="undertakers" @callback="changeIndex('undertakers')" v-bind="sliderTemplate" v-model="model.model.rightValues.undertakers"></vue-slider>
													</td>
													<td>{{ model.model.role.undertakers }}</td>
												</tr>
												<tr>
													<td>Benutzerverwaltung</td>
													<td>
														<vue-slider ref="users" @callback="changeIndex('users')" v-bind="sliderTemplate" v-model="model.model.rightValues.users"></vue-slider>
													</td>
													<td>{{ model.model.role.users }}</td>
												</tr>
												<tr>
													<td>Rollen</td>
													<td>
														<vue-slider ref="roles" @callback="changeIndex('roles')" v-bind="sliderTemplate" v-model="model.model.rightValues.roles"></vue-slider>
													</td>
													<td>{{ model.model.role.roles }}</td>
												</tr>
												<tr>
													<td>Flächenarten</td>
													<td>
														<vue-slider ref="area_categories" @callback="changeIndex('area_categories')" v-bind="sliderTemplate" v-model="model.model.rightValues.area_categories"></vue-slider>
													</td>
													<td>{{ model.model.role.area_categories }}</td>
												</tr>
												<tr>
													<td>Grabarten</td>
													<td>
														<vue-slider ref="grave_categories" @callback="changeIndex('grave_categories')" v-bind="sliderTemplate" v-model="model.model.rightValues.grave_categories"></vue-slider>
													</td>
													<td>{{ model.model.role.grave_categories }}</td>
												</tr>
												<tr>
													<td>Bestattungsarten</td>
													<td>
														<vue-slider ref="burial_types" @callback="changeIndex('burial_types')" v-bind="sliderTemplate" v-model="model.model.rightValues.burial_types"></vue-slider>
													</td>
													<td>{{ model.model.role.burial_types }}</td>
												</tr>
												<tr>
													<td>Konfessionen</td>
													<td>
														<vue-slider ref="denominations" @callback="changeIndex('denominations')" v-bind="sliderTemplate" v-model="model.model.rightValues.denominations"></vue-slider>
													</td>
													<td>{{ model.model.role.denominations }}</td>
												</tr>
												<tr>
													<td>Friedhofsverwaltung</td>
													<td>
														<vue-slider ref="graveyards" @callback="changeIndex('graveyards')" v-bind="sliderTemplate" v-model="model.model.rightValues.graveyards"></vue-slider>
													</td>
													<td>{{ model.model.role.graveyards }}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<!-- Vorgesetzter -->
		<custom-modal-old v-if="visibleModal === 'selectsuperior'" title="Vorgesetzen auswählen" @cancel="visibleModal = ''">
			<div class="row">
				<div class="col-lg-12">
					<custom-table select @select="pickSuperior" :src-model="$store.getters.models('users')" :cols="superiorSearchCols" store="categories" search :default-sort="defSort"></custom-table>
				</div>
			</div>
		</custom-modal-old>

		<!-- Rolle -->
		<custom-modal-old v-if="visibleModal === 'selectrole'" title="Rolle auswählen" @cancel="visibleModal = ''">
			<div class="row">
				<div class="col-lg-12">
					<custom-table select @select="pickRole" :src-model="$store.getters.models('roles')" :cols="roleSearchCols" store="categories" search :default-sort="defSort"></custom-table>
				</div>
			</div>
		</custom-modal-old>

		<!-- Adressen -->
		<custom-modal ref="addressModal" title="Adresse hinzufügen" ok-text="Speichern" cancel-text="Abbrechen" ok-style="btn btn-primary" cancel-style="btn btn-default">
			<address-content ref="newAddress"></address-content>
		</custom-modal>

		<custom-modal-old v-if="visibleModal === 'deleteaddresses'" title="Adresse löschen" ok-text="Löschen" cancel-text="Abbrechen" cancel-style="btn btn-primary" @ok="confirmDeleteRelation('addresses')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie diese Adresse entfernen möchten?</strong>
		</custom-modal-old>




		<!-- Kontakt -->
		<custom-modal ref="contactModal" title="Kontakt hinzufügen" ok-text="Speichern" cancel-text="Abbrechen" ok-style="btn btn-primary" cancel-style="btn btn-default">
			<contact-content ref="newContact"></contact-content>
		</custom-modal>

		<custom-modal-old title="Kontakt entfernen" v-if="visibleModal === 'deletecontacts'" ok-text="Löschen" cancel-text="Abbrechen" @ok="confirmDeleteRelation('contacts')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie diesen Kontakt entfernen möchten?</strong>
		</custom-modal-old>

		<!-- Fehlermeldungen -->
		<custom-modal-old v-if="visibleModal === 'errSavingModel'" @ok="visibleModal = ''" ok-text="OK" @cancel="visibleModal = ''">
			Fehler beim Speichern des Kunden.
		</custom-modal-old>
	</div>
</div>

</template>

<script>
import CustomTable from 'components/custom-table.vue'
import CustomModal from 'components/custom-modal.vue'
import CustomModalOld from 'components/custom-modal-old.vue'
import CustomInput from 'components/custom-input.vue'
import AddressContent from 'components/address-content.vue'
import ContactContent from 'components/contact-content.vue'

import Datepicker from 'vuejs-datepicker'
import vueSlider from 'vue-slider-component';

import UserModel from 'models/users.js'
import AddressesModel from 'models/addresses.js'
import ContactsModel from 'models/contacts.js'

import modelTools from 'functions/models.js'
import relationTools from 'functions/relations.js'
import addressTools from 'functions/address.js'
import contactTools from 'functions/contact.js'

import store from 'root/store.js'
import { authCheck, getSuperiorID } from 'functions/auth_check.js'
import { ModelListSelect } from 'vue-search-select'

export default {
	beforeRouteEnter (to, from, next) {
		const route = authCheck('users')
		if (route === null) {
			next()
		} else {
			next(route)
		}
	},

	beforeRouteLeave(to, from, next) {
		if (to.path === '/'+this.model.name+'/new') {
			this.model.clear()
		}
		next()
	},

	// Normale Eigenschaften
	data () {
		return {
			model: UserModel,

			roleSearchCols: [
				{
					name: 'Name',
					json: 'name',
					type: 'text'
				}
			],

			superiorSearchCols: [
				{
					name: 'Vorname',
					json: 'firstname',
					type: 'text'
				},
				{
					name: 'Nachname',
					json: 'lastname',
					type: 'text'
				}
			],

			// visibleModal: 'addgraves'
			visibleModal: '',

			defSort: {col: 'id', order: 'asc'},

			addresses: AddressesModel,
			contacts: ContactsModel,

			sliderCols: '["Aus Rolle übernehmen", "Kein Zugriff", "Lesen", "Ändern", "Löschen"]',

			sliderTemplate: {
				width: "80%",
				realTime: true,
				tooltip: "hover",
				disabled: false,
				piecewise: true,
				piecewiseLabel: true,
				show: true,
				data: [
					"Aus Rolle übernehmen",
					"Kein Zugriff",
					"Lesen",
					"Ändern",
					"Löschen"
				],
				piecewiseStyle: {
					"backgroundColor": "#ccc",
					"visibility": "visible",
					"width": "12px",
					"height": "12px"
				},
				piecewiseActiveStyle: {
					"backgroundColor": "#3498db"
				},
				labelActiveStyle: {
					"color": "#3498db"
				}
			}
		}
	},

	activated () {
		$(this.$refs.areaManagementRights).on('shown.bs.collapse', () => {
			this.refreshSliders()
		})
		$(this.$refs.areaSettingRights).on('shown.bs.collapse', () => {
			this.refreshSliders()
		})
		$('.collapse').collapse('hide')

		this.model.clear()
		this.model.model.id = parseInt(this.$route.params.id)
		if (isNaN(this.model.model.id)) {
			this.model.model.id = 0
		}

		this.$store.dispatch('loadModel', 'users')
		.then(() => {
			var model = this.$store.getters.model('users', this.model.model.id)
			this.model.copy(model)

			this.$store.dispatch('loadRelation', {basis: this.model, relation: 'addresses'})
			.then(data => this.initRelation('addresses', data))

			this.$store.dispatch('loadRelation', {basis: this.model, relation: 'contacts'})
			.then(data => this.initRelation('contacts', data))

			this.$store.dispatch('loadModels', this.model.relations)
			.then(() => {
				const currentRole = this.$store.getters.model('roles', this.model.model.role_id)
				const names = [
					"Aus Rolle übernehmen",
					"Kein Zugriff",
					"Lesen",
					"Ändern",
					"Löschen"
				]

				if (typeof currentRole !== 'undefined') {
					this.model.model.role = {
						dashboard: names[currentRole.permissions.dashboard],
						deceaseds: names[currentRole.permissions.deceaseds],
						customers: names[currentRole.permissions.customers],
						graves: names[currentRole.permissions.graves],
						areas: names[currentRole.permissions.areas],
						crematories: names[currentRole.permissions.crematories],
						undertakers: names[currentRole.permissions.undertakers],
						users: names[currentRole.permissions.users],
						roles: names[currentRole.permissions.roles],

						area_categories: names[currentRole.permissions.area_categories],
						grave_categories: names[currentRole.permissions.grave_categories],
						burial_types: names[currentRole.permissions.burial_types],
						denominations: names[currentRole.permissions.denominations],
						graveyards: names[currentRole.permissions.graveyards]
					}

					this.model.model.role_name = currentRole.name
				}
			})

			$('.responsive-tabs').responsiveTabs({
				accordionOn: ['xs', 'sm'] // xs, sm, md, lg
			})
		})
	},

	computed: {
		selectedZip: {
			get () {
				return {
					"zip": this.addresses.model.zip,
					"city": this.addresses.model.city
				}
			},

			set (aModel) {
				this.addresses.model.zip = aModel.zip
				this.addresses.model.city = aModel.city
			}
		},

		pageheader () {
			let model
			let name

			if (this.model.model.id === 0) {
				return 'Neuen Benutzer anlegen'
			} else {
				model = this.$store.getters.model('users', this.model.model.id)
				name = model.firstname + ' ' + model.lastname

				return 'Benutzer "' + name.trim() + '" verwalten'
			}
		}
	},

	components: {
		CustomTable,
		CustomModal,
		CustomModalOld,
		CustomInput,
		Datepicker,
		vueSlider,
		ModelListSelect,
		AddressContent,
		ContactContent
	},

	methods: {
		computeZip (aModel) {
			return aModel.zip + " " + aModel.city
		},

		// Tools des Models
		saveModel: modelTools.save,

		// Beziehungen zwischen Models
		initRelation: relationTools.init,
		editRelation: relationTools.edit,
		deleteRelation: relationTools.delete,
		addRelation: relationTools.add,
		saveRelation: relationTools.save,
		confirmDeleteRelation: relationTools.confirmDelete,

		// Adressen speziefische Methoden
		addressModal () {
			this.$refs.addressModal.open( () => {
				// Callback um zzu prüfen ob das Modal geschlossen werden kann
				if (this.$refs.newAddress.model.model.street.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.number.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.zip.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.city.trim() === "") {
					return false
				}

				return true
			})
			.then(() => {
				this.saveRelation('addresses')
			})
			.catch(() => {
				// Erfolgloses schließen
				console.log("CANCEL")
			})
		},

		addAddress () {
			this.addresses.clear()
			this.addressModal()
		},

		// Adressen speziefische Methoden
		editAddress (aModel) {
			this.addresses.copy(aModel)
			this.addressModal()
		},

		deleteAddress: addressTools.delete,

		// Kontakt speziefische Methoden
		contactModal () {
			this.$refs.contactModal.open( () => {
				if (this.$refs.newContact.model.model.value.trim() === "") {
					return false
				}

				return true
			})
			.then(() => {
				this.saveRelation('contacts')
			})
			.catch(() => {
				console.log("CANCEL")
			})
		},

		addContact () {
			this.contacts.clear()
			this.contactModal()
		},

		// Adressen speziefische Methoden
		editContact (aModel) {
			this.contacts.copy(aModel)
			this.contactModal()
		},

		deleteContact: contactTools.delete,

		selectRole () {
			this.visibleModal = 'selectrole'
		},

		selectSuperior () {
			this.visibleModal = 'selectsuperior'
		},

		pickRole (aModel) {
			this.model.model.role_id = aModel.id
			this.model.model.role_name = aModel.name
			this.visibleModal = ''
		},

		pickSuperior (aModel) {
			if (aModel.id !== this.model.model.id) {
				this.model.model.superior_id = aModel.id
				this.model.model.superior_name = aModel.name
			}
			this.visibleModal = ''
		},

		refreshSliders () {
			this.$refs.dashboard.setIndex(this.model.model.rights.dashboard)
			this.$refs.deceaseds.setIndex(this.model.model.rights.deceaseds)
			this.$refs.customers.setIndex(this.model.model.rights.customers)
			this.$refs.graves.setIndex(this.model.model.rights.graves)
			this.$refs.areas.setIndex(this.model.model.rights.areas)
			this.$refs.crematories.setIndex(this.model.model.rights.crematories)
			this.$refs.undertakers.setIndex(this.model.model.rights.undertakers)
			this.$refs.users.setIndex(this.model.model.rights.users)
			this.$refs.roles.setIndex(this.model.model.rights.roles)

			this.$refs.area_categories.setIndex(this.model.model.rights.area_categories)
			this.$refs.grave_categories.setIndex(this.model.model.rights.grave_categories)
			this.$refs.burial_types.setIndex(this.model.model.rights.burial_types)
			this.$refs.denominations.setIndex(this.model.model.rights.denominations)
			this.$refs.graveyards.setIndex(this.model.model.rights.graveyards)


			this.$refs.dashboard.refresh()
			this.$refs.deceaseds.refresh()
			this.$refs.customers.refresh()
			this.$refs.graves.refresh()
			this.$refs.areas.refresh()
			this.$refs.crematories.refresh()
			this.$refs.undertakers.refresh()
			this.$refs.users.refresh()
			this.$refs.roles.refresh()

			this.$refs.area_categories.refresh()
			this.$refs.grave_categories.refresh()
			this.$refs.burial_types.refresh()
			this.$refs.denominations.refresh()
			this.$refs.graveyards.refresh()
		},

		changeIndex(aSlider) {
			this.model.model.rights[aSlider] = this.$refs[aSlider].getIndex()
		},

		saveUser () {
  			let rights = {
				deceaseds: this.model.model.rights.deceaseds,
				customers: this.model.model.rights.customers,
				graves: this.model.model.rights.graves,
				areas: this.model.model.rights.areas,
				settings: this.model.model.rights.settings,
				crematories: this.model.model.rights.crematories,
				undertakers: this.model.model.rights.undertakers
			}

			this.saveModel()
			.then(id => {
				this.model.model.id = id
				this.$router.replace("/users/" + id)
			})
			.catch(id => {
				this.model.model.id = id
			})
		},

		isSuperadmin () {
			const SuperiorID = getSuperiorID()
			console.log(SuperiorID)
			return (SuperiorID === 0) || (SuperiorID === 1)
		}
	}
}
</script>



// WEBPACK FOOTER //
// UserEdit.vue?156d690b